import { ProjectsService } from "@/common/api.service";
import { FETCH_ABOUT_PROJECT, FETCH_SCENARIO_PROJECT } from "./actions.type";
import {
  FETCH_ABOUT_PROJECT_START,
  FETCH_ABOUT_PROJECT_END,
  FETCH_ABOUT_PROJECT_ERROR,
  FETCH_SCENARIO_PROJECT_START,
  FETCH_SCENARIO_PROJECT_END,
  FETCH_SCENARIO_PROJECT_ERROR
} from "./mutations.type";

const state = {
  aboutProject: {
    PROJECT_MAIN_INFO:{},
    REQUEST_INFO: {},
  },
  scenarioProject: null,
  isProjectScenarioLoading: false,
  error: null
};

const getters = {
  aboutProject: state => state.aboutProject,
  scenarioProject: state => state.scenarioProject,
  isProjectScenarioLoading: state => state.isProjectScenarioLoading,
  error: state => state.error
};

const actions = {
  [FETCH_ABOUT_PROJECT]({ commit }, id) {
    commit(FETCH_ABOUT_PROJECT_START);
    return ProjectsService.getAboutProject(id)
      .then(({ data }) => {
        commit(FETCH_ABOUT_PROJECT_END, data);
      })
      .catch(error => {
        commit(FETCH_ABOUT_PROJECT_ERROR, error);
        throw new Error(error);
      });
  },

  [FETCH_SCENARIO_PROJECT]({ commit }, id) {
    commit(FETCH_SCENARIO_PROJECT_START);
    return ProjectsService.getScenarioProject(id)
      .then(({ data }) => {
        commit(FETCH_SCENARIO_PROJECT_END, data);
      })
      .catch(error => {
        commit(FETCH_SCENARIO_PROJECT_ERROR, error);
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_ABOUT_PROJECT_START](state) {
    state.isProjectScenarioLoading = true;
    state.error = null;
  },
  [FETCH_ABOUT_PROJECT_END](state, data) {
    state.aboutProject = data;
    state.isProjectScenarioLoading = false;
  },
  [FETCH_ABOUT_PROJECT_ERROR](state, error) {
    state.error = error;
    state.isProjectScenarioLoading = false;
  },
  [FETCH_SCENARIO_PROJECT_START](state) {
    state.isProjectScenarioLoading = true;
    state.error = null;
  },
  [FETCH_SCENARIO_PROJECT_END](state, data) {
    state.scenarioProject = data;
    state.isProjectScenarioLoading = false;
  },
  [FETCH_SCENARIO_PROJECT_ERROR](state, error) {
    state.error = error;
    state.isProjectScenarioLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
